(function () {
  function initReviewsSlider(root) {
    if (!root || root.dataset.reviewsSliderReady === 'true') return;

    var track = root.querySelector('[data-reviews-slider-track]');
    var prevButton = root.querySelector('[data-reviews-slider-prev]');
    var nextButton = root.querySelector('[data-reviews-slider-next]');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.slide-wrapper'));
    if (!slides.length) return;

    var viewport = track.parentElement || track;
    var index = 0;
    var resizeTimer = null;
    var loop = root.getAttribute('data-reviews-slider-loop') !== 'false';

    var pointerId = null;
    var startX = 0;
    var startY = 0;
    var deltaX = 0;
    var dragging = false;
    var axisLocked = null;
    var SWIPE_THRESHOLD = 48;
    var AXIS_LOCK_THRESHOLD = 8;

    function getColumns() {
      var value = window.getComputedStyle(root.closest('.shopify-section') || root).getPropertyValue('--slide-columns');
      var columns = parseInt(value, 10);
      return columns > 0 ? columns : 1;
    }

    function getMaxIndex() {
      return Math.max(0, slides.length - getColumns());
    }

    function updateNavVisibility() {
      var maxIndex = getMaxIndex();
      var canSlide = maxIndex > 0;

      if (!canSlide) {
        if (prevButton) {
          prevButton.hidden = true;
          prevButton.disabled = true;
        }
        if (nextButton) {
          nextButton.hidden = true;
          nextButton.disabled = true;
        }
        return;
      }

      if (prevButton) {
        prevButton.hidden = false;
        prevButton.disabled = !loop && index <= 0;
      }
      if (nextButton) {
        nextButton.hidden = false;
        nextButton.disabled = !loop && index >= maxIndex;
      }
    }

    function baseTranslate() {
      return 'calc(-' + index + ' * 100% / var(--slide-columns))';
    }

    function goTo(nextIndex, instant) {
      var maxIndex = getMaxIndex();

      if (loop) {
        if (nextIndex > maxIndex) {
          nextIndex = 0;
        } else if (nextIndex < 0) {
          nextIndex = maxIndex;
        }
      } else {
        nextIndex = Math.max(0, Math.min(nextIndex, maxIndex));
      }

      index = nextIndex;

      if (instant) {
        track.classList.add('is-resizing');
      } else {
        track.classList.remove('is-resizing');
      }

      track.style.transform = 'translateX(' + baseTranslate() + ')';

      if (instant) {
        track.offsetHeight;
        track.classList.remove('is-resizing');
      }

      updateNavVisibility();
    }

    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        var maxIndex = getMaxIndex();
        if (index > maxIndex) {
          goTo(maxIndex, true);
        } else {
          goTo(index, true);
        }
      }, 100);
    }

    function onPointerDown(event) {
      if (getMaxIndex() <= 0) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('a, button, input, textarea, select, label, [data-description-toggle]')) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      deltaX = 0;
      dragging = false;
      axisLocked = null;

      if (viewport.setPointerCapture) {
        try {
          viewport.setPointerCapture(pointerId);
        } catch (error) {
          // Ignore capture errors from unsupported hosts.
        }
      }
    }

    function onPointerMove(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      var dx = event.clientX - startX;
      var dy = event.clientY - startY;

      if (!axisLocked) {
        if (Math.abs(dx) < AXIS_LOCK_THRESHOLD && Math.abs(dy) < AXIS_LOCK_THRESHOLD) return;
        axisLocked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axisLocked === 'y') return;
      }

      if (axisLocked === 'y') return;

      dragging = true;
      deltaX = dx;

      if (!loop) {
        var maxIndex = getMaxIndex();
        if ((index <= 0 && deltaX > 0) || (index >= maxIndex && deltaX < 0)) {
          deltaX *= 0.35;
        }
      }

      if (event.cancelable) event.preventDefault();

      track.classList.add('is-resizing');
      track.style.transform = 'translateX(calc(' + baseTranslate() + ' + ' + deltaX + 'px))';
    }

    function endPointer(event) {
      if (pointerId === null || (event && event.pointerId !== pointerId)) return;

      var wasDragging = dragging;
      var finalDelta = deltaX;

      if (viewport.releasePointerCapture && pointerId !== null) {
        try {
          if (viewport.hasPointerCapture && viewport.hasPointerCapture(pointerId)) {
            viewport.releasePointerCapture(pointerId);
          }
        } catch (error) {
          // Ignore release errors from unsupported hosts.
        }
      }

      pointerId = null;
      dragging = false;
      axisLocked = null;
      deltaX = 0;

      if (!wasDragging) return;

      if (Math.abs(finalDelta) >= SWIPE_THRESHOLD) {
        goTo(finalDelta < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }
    }

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(index - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(index + 1);
      });
    }

    viewport.style.touchAction = 'pan-y';
    viewport.addEventListener('pointerdown', onPointerDown);
    viewport.addEventListener('pointermove', onPointerMove, { passive: false });
    viewport.addEventListener('pointerup', endPointer);
    viewport.addEventListener('pointercancel', endPointer);
    viewport.addEventListener('lostpointercapture', endPointer);

    window.addEventListener('resize', onResize);
    goTo(0, true);
    root.dataset.reviewsSliderReady = 'true';
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-reviews-slider]');
    for (var i = 0; i < roots.length; i++) {
      initReviewsSlider(roots[i]);
    }
  }

  function onReady() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;

    var roots = event.target.querySelectorAll('[data-reviews-slider]');
    for (var i = 0; i < roots.length; i++) {
      delete roots[i].dataset.reviewsSliderReady;
      initReviewsSlider(roots[i]);
    }
  });
})();
